import { render, staticRenderFns } from "./DomainCategorySettings.vue?vue&type=template&id=a93b2c30"
import script from "./DomainCategorySettings.vue?vue&type=script&lang=ts"
export * from "./DomainCategorySettings.vue?vue&type=script&lang=ts"
import style0 from "./DomainCategorySettings.vue?vue&type=style&index=0&id=a93b2c30&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports